"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentDeleteInvoicePopup = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Confirm_1 = require("../../../../Popup/Confirm");
require("./index.scss");
const className = 'allotment-delete-invoice-popup';
const AllotmentDeleteInvoicePopup = (props) => {
    const { invoice, isOpened, isLoading, onConfirm, onClose } = props;
    const popupConfirmProps = {
        isOpened,
        isLoading,
        onConfirm,
        onClose,
        confirmMessage: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/InvoiceList/AllotmentDeleteInvoicePopup:title', defaultMessage: 'Are you sure you want to delete this invoice?' })),
        isConfirmRed: true,
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Confirm_1.PopupConfirm, { ...popupConfirmProps },
            react_1.default.createElement("div", null, invoice === null || invoice === void 0 ? void 0 : invoice.title))));
};
exports.AllotmentDeleteInvoicePopup = AllotmentDeleteInvoicePopup;
//# sourceMappingURL=index.js.map